import { Action } from '@ngrx/store';

import { RouterRequestActionType } from './router-request-action-type.enum';

export class RouterForwardRequest implements Action {
  public readonly type: RouterRequestActionType = RouterRequestActionType.RouterForwardRequest;

  constructor(public readonly payload: void = undefined) { }
}
